import React, { useEffect, useState } from 'react';
import OttServiceOptionsModal from './OttServiceOptionsModal';
import styles from './OttServiceOptionsPopup.module.scss';
import FalconButtonV2 from '../../FalconButtonV2/FalconButtonV2';
import RichText from '../../richtext';
import {
  AssetPathPropConfig,
  LineTableBasicPropConfig
} from '../../../services/LineTableBasicPropConfig';
import { CMSStoryblokServiceV2 } from '@sunrise-upc/ajax-lib';
import { countZero, replacePlaceholder } from '../../../utils/utils';
import { SBENDPOINT } from '../../../services/api-constants';
import OttServiceOptionsLoader from './OttServiceOptionsLoader/OttServiceOptionsLoader';

const OttServiceOptionsPopup = ({
  content,
  showPopup,
  setShowPopup,
  addOptionsCallBack,
  metadata,
  constants,
  mainContent,
  preSelectedOptions,
  optionsResponse,
  updateResponseList
}: any) => {
  const sbEndpoint = LineTableBasicPropConfig?.getInstance()?.getSBUrl();
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  const basicConfigUrl = AssetPathPropConfig?.getInstance()?.getBasicConfigUrl();
  const activelocaleId: string | undefined = metadata?.lang;
  const [sbData, setSbData] = useState([]);
  const [optionsList, setOptionsList] = useState<any>();
  const [selectedOptions, setSelectedOptions] = useState<any[]>(preSelectedOptions);
  const [totalPrice, setTotalPrice] = useState(0);

  //Footer section
  const footer = () => {
    let addButtonContent = JSON.stringify(content?.primaryBtn?.[0]);
    if (selectedOptions?.length === 0) {
      addButtonContent = replacePlaceholder(addButtonContent, [' ']);
    } else if (selectedOptions?.length > 0) {
      addButtonContent = replacePlaceholder(addButtonContent, [`(${selectedOptions?.length})`]);
    }
    return (
      <div className={styles.footer}>
        {totalPrice > 0 && (
          <div className={styles.totalPrice}>
            +{countZero(totalPrice)}
            {constants?.month}
          </div>
        )}
        <div className={styles.buttonSection}>
          {content?.secondaryBtn?.length > 0 && (
            <FalconButtonV2
              content={content?.secondaryBtn?.[0]}
              className={styles.closeButton}
              onClick={() => setShowPopup(false)}
              wafIdentifier={basicConfigUrl}
            />
          )}
          {content?.primaryBtn?.length > 0 && (
            <FalconButtonV2
              content={JSON.parse(addButtonContent)}
              className={styles.addButton}
              onClick={() => addOptionsHandler()}
              disabled={selectedOptions?.length === 0 && preSelectedOptions?.length === 0}
              wafIdentifier={basicConfigUrl}
            />
          )}
        </div>
      </div>
    );
  };

  //On click of submit
  const addOptionsHandler = () => {
    setShowPopup(false);
    addOptionsCallBack(selectedOptions);
  };

  //on click of options
  const clickHandler = (option: any) => {
    if (option?.disable === 0) {
      let selectedOptsList = [...selectedOptions];
      const grpList = Object?.keys(optionsList || []);
      let tempGroupList: any = [];
      let selectedIdslist: any[] = [];
      let beneficiaryProduct: any[] = [];
      let includedOptions: any[] = [];
      let selectedOptsDuplicate: any[] = [...selectedOptions];
      if (option?.count === 0) {
        selectedOptsDuplicate?.push(option);
      }
      //loop to fetch the included options and beneficiary products list
      (selectedOptsDuplicate || [])?.forEach((sel: any) => {
        if (
          !option?.conflicts?.includes(sel?.id) &&
          !(sel?.id === option?.id && sel?.count === 1)
        ) {
          if (sel?.beneficiaryProduct?.length > 0) {
            beneficiaryProduct?.push(...sel?.beneficiaryProduct);
          }
          if (sel?.includedOption?.length > 0) {
            includedOptions?.push(...sel?.includedOption);
          }
          selectedIdslist?.push(sel?.id);
        }
      });

      //loop to update the optionsList and the selected options list on click of option card
      grpList &&
        grpList?.length > 0 &&
        (grpList || [])?.forEach((grps: any) => {
          let tempOptList = optionsList?.[`${grps}`]?.map((item: any) => {
            item.beneficiaryPrice = 0;
            item.disable = 0;
            if (option && option?.count === 0 && item?.id === option?.id) {
              item.count = 1;
              selectedOptsList?.push({ ...option, group: grps });
            } else if (option && option?.count === 1 && item?.id === option?.id) {
              item.count = 0;
              selectedOptsList = (selectedOptsList || [])?.filter((opt) => opt?.id !== option?.id);
            }
            if (option && option?.conflicts?.includes(item?.id) && item?.count === 1) {
              item.count = 0;
              selectedOptsList = (selectedOptsList || [])?.filter((opt) => opt?.id !== item?.id);
            }
            if (includedOptions?.length > 0 && includedOptions?.includes(item?.id)) {
              item.disable = 1;
            }
            if (beneficiaryProduct?.length > 0) {
              const matchedOpt = beneficiaryProduct?.filter((prod: any) => prod?.id === item?.id);
              if (matchedOpt?.length > 0) {
                item.beneficiaryPrice = matchedOpt?.[0]?.derivedPrice;
                if (selectedIdslist?.includes(item?.id)) {
                  selectedOptsList = (selectedOptsList || [])?.map((selected: any) => {
                    return selected?.id === item?.id ? item : selected;
                  });
                }
              }
            }
            return item;
          });
          tempGroupList[`${grps}`] = tempOptList;
        });
      setSelectedOptions(selectedOptsList);
      setOptionsList(tempGroupList);
    }
  };

  //Stories API call to get details of options from SB
  useEffect(() => {
    if (sbData && sbData?.length === 0) {
      const url = `${sbEndpoint}${SBENDPOINT.STORIES_URL}`;
      let groupList = '';
      (content?.content || [])?.forEach((opt: any) => {
        if (opt?.component === 'optionsCard' && opt?.optionsGroup !== '') {
          groupList = groupList?.concat(`${opt?.optionsGroup?.toLowerCase()},`);
        }
      });
      const filterQuery = `filter_query[isSellable][is]=true&filter_query[tvStreamingSubCategoryList][in]=${groupList}&filter_query[component][in]=optionProductBasePage&per_page=50&language=${activelocaleId}`;
      const params = {
        type: 'B2C',
        starts_with: mainContent?.optionCatalogPath ?? '',
        filterQueryParam: filterQuery
      };
      const story = [];
      CMSStoryblokServiceV2.get(url, params)
        .then((data) => {
          if (data?.data?.stories?.length > 0) {
            setSbData(data?.data?.stories);
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    }
  }, [content]);

  //To get the details of the options from SB based on the option 
  useEffect(() => {
    if (optionsResponse?.length > 0) {
      updateResponseList(optionsResponse);
    }
    if (sbData?.length > 0 && optionsResponse?.length > 0 && content?.content?.length > 0) {
      let selectedIdslist: any[] = [];
      let beneficiaryProduct: any[] = [];
      let includedOptions: any[] = [];
      let defaultSelectedOpts: any[] = [];
      (preSelectedOptions || [])?.forEach((sel: any) => {
        if (sel?.beneficiaryProduct?.length > 0) {
          beneficiaryProduct?.push(...sel?.beneficiaryProduct);
        }
        if (sel?.includedOption?.length > 0) {
          includedOptions?.push(...sel?.includedOption);
        }
        selectedIdslist?.push(sel?.id);
      });
      let groupedOptions: any = [];
      (content?.content || [])?.map((comp: any) => {
        let optsList = [];
        if (comp?.component === 'optionsCard') {
          let groupWithOptions: any = (optionsResponse || [])?.filter(
            (resp: any) => resp?.group?.toLowerCase() === comp?.optionsGroup?.toLowerCase()
          )?.[0];
          if (groupWithOptions?.serviceOption?.length > 0) {
            optsList = groupWithOptions?.serviceOption?.map((opt: any) => {
              let optionData: any = (sbData || [])?.filter(
                (i: any) => i?.content?.code === opt?.id
              )?.[0];
          let defaultBeneficiaryPrice = 0;
              if (beneficiaryProduct?.length > 0) {
                const beneficiaryPrice = (beneficiaryProduct || [])?.filter(
                  (prod: any) => prod?.id === opt?.id
                );
                if (beneficiaryPrice?.length > 0) {
                  defaultBeneficiaryPrice = beneficiaryPrice?.[0]?.derivedPrice;
                }
              }
              const data = {
                ...opt,
                count: selectedIdslist?.includes(opt?.id) ? 1 : 0,
                disable: includedOptions?.includes(opt?.id) ? 1 : 0,
                beneficiaryPrice: defaultBeneficiaryPrice,
                ...(optionData?.content?.displayTitle && {
                  title: optionData?.content?.displayTitle
                }),
                ...(optionData?.content?.features && { features: optionData?.content?.features }),
                ...(optionData?.content?.badge && { badge: optionData?.content?.badge })
              };
              if (selectedIdslist?.includes(opt?.id)) {
                defaultSelectedOpts?.push(data);
              }
              return data;
            });
          }
        }
        if (optsList?.length > 0) groupedOptions[`${comp?.optionsGroup}`] = optsList;
      });
      if (groupedOptions && Object?.keys(groupedOptions)?.length > 0) {
        setOptionsList(groupedOptions);
      }
      if (defaultSelectedOpts?.length > 0) {
        setSelectedOptions(defaultSelectedOpts);
      }
    }
  }, [sbData, optionsResponse]);

  //price calculation to get the total price of all the options
  useEffect(() => {
    let total = 0;
    (selectedOptions || [])?.forEach((item: any) => {
      if (item?.beneficiaryPrice > 0) {
        total += parseFloat(item?.beneficiaryPrice);
      } else if (item?.derivedPrice > 0) {
        total += parseFloat(item?.derivedPrice);
      } else if (item?.recurringPrice) {
        total += parseFloat(item?.recurringPrice);
      }
    });
    setTotalPrice(total);
  }, [selectedOptions]);

  return (
    <OttServiceOptionsModal
      modalState={showPopup}
      handler={() => setShowPopup(!showPopup)}
      content={content}
      showFooter={true}
      height={'100%'}
      footerNode={footer}
    >
      {(content?.content || [])?.map((comp: any) => (
        <div className={styles.mainWrapper}>
          {comp?.component === 'richText' && comp?.text && <RichText content={comp?.text} />}{' '}
          {comp?.component === 'optionsCard' && optionsList?.[`${comp?.optionsGroup}`] && (
            <div className={styles.plans}>
              <div className={styles.planTitleSection}>
                <img
                  src={comp?.icon?.filename}
                  alt='planIcon'
                  width={40}
                  height={40}
                  className={styles.planIcon}
                />
                <div>
                  <div className='d-flex'>
                    {comp?.title && <div className={styles.planTitle}>{comp?.title}</div>}
                    {comp?.badge && <div className={styles.badge}>{comp?.badge}</div>}
                  </div>
                  {comp?.subtitle && <div>{comp?.subtitle}</div>}
                </div>
              </div>
              <div className={styles.cardWrapper}>
                {optionsList &&
                  Object?.keys(optionsList)?.length > 0 &&
                  optionsList?.[`${comp?.optionsGroup}`] &&
                  (optionsList?.[`${comp?.optionsGroup}`] || [])?.map((optionsData: any) => (
                    <div
                      className={`${styles.cards} ${
                        optionsData?.count > 0 && styles.selectedOption
                      } ${optionsData?.disable > 0 && styles.disableCard}`}
                      onClick={() => clickHandler(optionsData)}
                    >
                      {optionsData?.count > 0 && (
                        <div className={styles.overlayIcon}>
                          <img
                            src={`${assetPath}/icons/lineCheck-success.svg`}
                            width={26}
                            height={26}
                            alt='success'
                          />
                        </div>
                      )}
                      <div className='fw-bold'>{optionsData?.title}</div>
                      <div className={styles.priceSection}>
                        <div className={styles.actualPrice}>
                          {optionsData?.beneficiaryPrice > 0 &&
                            `+${countZero(optionsData?.beneficiaryPrice)}${constants?.month}`}
                          {optionsData?.beneficiaryPrice === 0 &&
                            (optionsData?.derivedPrice
                              ? `+${countZero(optionsData?.derivedPrice)}${constants?.month}`
                              : `+${countZero(optionsData?.recurringPrice)}${constants?.month}`)}
                        </div>
                        <div className={styles.basePrice}>
                          {(optionsData?.derivedPrice || optionsData?.beneficiaryPrice > 0) &&
                            optionsData?.recurringPrice > 0 &&
                            `+${countZero(optionsData?.recurringPrice)}${constants?.month}`}
                        </div>
                      </div>
                      {optionsData?.badge && (
                        <div className={styles.badge}>{optionsData?.badge}</div>
                      )}
                      {optionsData?.features && (
                        <div className={styles.features}>
                          <RichText content={optionsData?.features} />
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      ))}
      {Object?.keys(optionsList || [])?.length === 0 && <OttServiceOptionsLoader />}
    </OttServiceOptionsModal>
  );
};

export default OttServiceOptionsPopup;
